import React, { useState } from "react";
import {
  List,
  useTable,
  EditButton,
  DeleteButton,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { ISearch } from "type";
import { useExport } from "@pankod/refine-core";

export const TagUserRewardList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "tag_user_reward_id",
        title: "Tag User Reward Id",
        type: "number",
        width: 200,
      },
      {
        dataIndex: "tag_action_id",
        title: "Tag Action Id",
        width: 200,
        type: "number",
      },
      {
        dataIndex: "tag_reward_id",
        title: "Tag Reward Id",
        type: "number",
        width: 200,
      },
      {
        dataIndex: "user_id",
        title: "User Id",
        type: "number",
        width: 200,
      },
      {
        dataIndex: "created_at",
        title: "Created At",
        width: 200,
      },
      {
        dataIndex: "updated_at",
        title: "Updated At",
        width: 200,
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          {defaultButtons}
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="tag_user_reward_id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
